import React from 'react'
import Logo from '@/components/Common/header/logo'

interface LogoLoaderProps {
  host: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
  showText?: boolean
}

const LogoLoader: React.FC<LogoLoaderProps> = ({
  host,
  size = 'md',
  className = '',
  showText = true,
}) => {
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
  }

  const logoSizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  }

  console.info(host, 'host')

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`relative ${sizeClasses[size]} flex items-center justify-center`}
      >
        {/* Animated Ring */}
        <div className="absolute inset-0 rounded-full border-2 border-gray-200" />
        <div
          className="absolute inset-0 animate-spin rounded-full border-2 border-blue-500 border-t-transparent"
          style={{ animationDuration: '1.5s' }}
        />

        {/* Logo in Center */}
        <div
          className={`relative z-10 flex items-center justify-center ${logoSizeClasses[size]}`}
        >
          <Logo host={host} disablePointer />
        </div>
      </div>

      {showText && (
        <p className="mt-4 animate-pulse text-sm font-medium text-gray-600">
          Loading...
        </p>
      )}
    </div>
  )
}

export default LogoLoader
